import React, { useEffect, useState, useRef } from 'react';
import styles from './NewFeaturesAccordion.module.css';
import { collection, query, orderBy, getDocs, onSnapshot } from 'firebase/firestore';
import { auth, firestore} from "../../firebase/firebase.js";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import rehypeLinks from 'rehype-external-links';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi2';
import { getFirestoreCache } from "../../hooks/getCallableCachedPromisData";
import Button from '../ui/Button';

const ONE_MINUTES = 1 * 60 * 1000;


export default function NewFeaturesAccordion() {
  const [features, setFeatures] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [highlight, setHighlight] = useState(false);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const refs = useRef({});
  
  useEffect(() => {
    async function fetchFeatures() {
      /*const q = query(collection(firestore, 'newFeatures'), orderBy('order'));
      const snap = await getDocs(q);
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFeatures(data);*/

	const q = query(collection(firestore, 'newFeatures'), orderBy('order'));
	const data = await getFirestoreCache(q, 'newfeatures_cache', ONE_MINUTES);
	setFeatures(data);

    const featureId = params.get('feature');
      if (featureId && data.some(f => f.id === featureId)) {
        setOpenId(featureId);
		setHighlight(true);
        setTimeout(() => {
          refs.current[featureId]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 400);
      }
    }
    fetchFeatures();
  }, [params]);
  
  /*useEffect(() => {
	var data;
	const q = query(collection(firestore, 'newFeatures'), orderBy('order'));	
	const unsubscribe = onSnapshot(q, (snapshot) => {
	  data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	  setFeatures(data);
	});

	// Set openId from URL param (if valid)
	const featureId = params.get('feature');
	if (featureId && data.some(f => f.id === featureId)) {
	setOpenId(featureId);
	setHighlight(true);
	setTimeout(() => {
	  refs.current[featureId]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}, 400);
	}
	return () => unsubscribe();
  }, [params]);*/
  
  /*useEffect(() => {
    async function fetchFeatures() {
      const q = query(collection(firestore, 'newFeatures'), orderBy('order'));
      const snap = await getDocs(q);
      setFeatures(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
    fetchFeatures();
  }, []);*/

  useEffect(() => {
	  async function fetchInitialData() {
		const q = query(collection(firestore, 'newFeatures'), orderBy('order'));
		const list = await getFirestoreCache(q, 'newfeatures_cache', ONE_MINUTES);
		setFeatures(list);
	  }

	  fetchInitialData();
  }, []);
  

  //const toggle = id => setOpenId(prev => (prev === id ? null : id));
  const toggle = (id) => {
    setHighlight(false);
    const isSame = openId === id;
    setOpenId(isSame ? null : id);
    if (!isSame) {
      setTimeout(() => {
        refs.current[id]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }
  };
  
  const handleBack = () => {
    navigate('/home');
  };

  return (
    <div className={styles.accordion}>
	  {highlight == true ? <Button className={styles.backBtn} onClick={handleBack}>Back to Homepage</Button> : <></>}
      {features.map(feature => (
        <div key={feature.id} className={`${styles.item} ${openId === feature.id && highlight == true ? styles.opened : ''}`}>
          <div className={styles.header} onClick={() => toggle(feature.id)}>
            <h3>{feature.title}</h3>
            {openId === feature.id ? <HiChevronUp /> : <HiChevronDown />}
          </div>
          {openId === feature.id && (
            <div className={styles.body}>
              <ReactMarkdown rehypePlugins={[rehypeRaw, remarkGfm, rehypeLinks]}>{feature.details || feature.description}</ReactMarkdown>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
